import { RedirectIcon } from "./RedirectIcon";

export default RedirectIcon;
